import { ReactNode } from 'react'
import TopBar from './TopBar'
import ResourceBar from './ResourceBar'

interface GameLayoutProps {
  children: ReactNode
}

export default function GameLayout({ children }: GameLayoutProps) {
  return (
    <div className="flex flex-col bg-slate-950 relative" style={{ height: '100dvh' }}>
      {/* Top Bar */}
      <TopBar />

      {/* Resource Bar */}
      <ResourceBar />

      {/* Main Content */}
      <main className="flex-1 relative z-10 overflow-hidden">
        {children}
      </main>
    </div>
  )
}
